import React, { Fragment, useState, useRef, useEffect } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { connect } from "react-redux";
import PageTitle from "../../layouts/PageTitle";
import { Formik } from "formik";
import * as Yup from "yup";
import { useAuth } from "../../../context/AuthContext";

import { notifyTopRight, notifyWarning, notifyError } from "../toast/SetToast";
import Toast from "../toast/SetToast";
import { Badge, Button, Row, Col, Card, Tabs, Tab, Nav } from "react-bootstrap";
import ProductDetail from "./ProductDetail";
import { startEditCpap, startSetCpap, startSetCpaps } from "../../../actions/cpaps";
import selectCpaps from "../../../selectors/cpaps";
import ProductActivity from "./ProductActivity";
import ProductFiles from "./ProductFiles/ProductFiles";

const ProductPage = (props) => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [showCpapStatus, setShowCpapStatus] = useState("");
  const [showPage, setShowPage] = useState(0);

  const onSubmit = (updates) => {
    props
      .startEditCpap(updates.id, updates, updates.images)
      .then(() => {
        notifyTopRight("Updated !");
      })
      .catch((error) => {
        notifyError(error);
      });
  };

  const tabData = [
    {
      name: "Detail",
      icon: "user",
      content: function (props, setState) {
        return <ProductDetail cpap={props} onEdit={setState} />;
      },
    },
    {
      name: "Activity",
      icon: "clipboard",
      content: function (props, setState) {
        return <ProductActivity cpap={props} />;
      },
    },
    {
      name: "Files",
      icon: "clipboard",
      content: function (props, setState) {
        return <ProductFiles cpap={props} />;
      },
    },
  ];
  useEffect(() => {
    setIsLoading(true);
    // Load CPAP data if not already loaded
    props.startSetCpaps().then(() => {
      setIsLoading(false);
    }).catch(() => {
      setIsLoading(false);
    });
  }, []);

  // Check if we have valid cpap data
  if (isLoading) {
    return (
      <>
        <PageTitle
          activeMenu="Product Detail"
          motherMenu="Sales"
          motherLink="/product-list"
        />
        <Toast />
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </>
    );
  }

  if (!props.cpap || props.cpap.length === 0) {
    return (
      <>
        <PageTitle
          activeMenu="Product Detail"
          motherMenu="Sales"
          motherLink="/product-list"
        />
        <Toast />
        <Card>
          <Card.Header>
            <Card.Title>Product Not Found</Card.Title>
          </Card.Header>
          <Card.Body>
            <p>The requested product could not be found.</p>
          </Card.Body>
        </Card>
      </>
    );
  }

  const currentCpap = props.cpap[0];

  return (
    <>
      <PageTitle
        activeMenu="Product Detail"
        motherMenu="Sales"
        motherLink="/product-list"
      />
      <Toast />
      {isLoading ? (
        <></>
      ) : (
        <Card>
          <Card.Header>
            <Card.Title>Product Information</Card.Title>
            <Card.Title>
              {currentCpap.status === "ว่าง" ? (
                <Badge variant="info dark">{currentCpap.status}</Badge>
              ) : currentCpap.status === "จอง" ? (
                <Badge variant="warning dark">{currentCpap.status}</Badge>
              ) : currentCpap.status === "ยกเลิก" ? (
                <Badge variant="danger dark">{currentCpap.status}</Badge>
              ) : (
                <Badge variant="success light">{currentCpap.status}</Badge>
              )}
              {/* <Badge variant="success light">{currentCpap.status}</Badge> */}
            </Card.Title>
          </Card.Header>
          <Card.Body>
            {/* <!-- Nav tabs --> */}
            <div className="default-tab">
              <Tab.Container
                defaultActiveKey={tabData[showPage].name.toLowerCase()}
              >
                <Nav as="ul" className="nav-tabs">
                  {tabData.map((data, i) => (
                    <Nav.Item as="li" key={i}>
                      <Nav.Link eventKey={data.name.toLowerCase()}>
                        <i className={`la la-${data.icon} mr-2`} />
                        {data.name}
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
                <Tab.Content className="pt-4">
                  {tabData.map((data, i) => (
                    <Tab.Pane eventKey={data.name.toLowerCase()} key={i}>
                      {data.content(currentCpap, onSubmit)}
                    </Tab.Pane>
                  ))}
                </Tab.Content>
              </Tab.Container>
            </div>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  // Extract id from URL params - handle both old and new router versions
  const id = (ownProps.match && ownProps.match.params && ownProps.match.params.id) || 
             (window.location.pathname.split('/').pop());
  
  return {
    cpap: selectCpaps(state.cpaps, { text: id }),
  };
};

const mapDispatchToProps = (dispatch) => ({
  startEditCpap: (id, updates, files) =>
    dispatch(startEditCpap(id, updates, files)),
  startSetCpaps: () => dispatch(startSetCpaps()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductPage);
